<template>
<div class="container-fluid">
	<toolbar>
		<h2>
			<i class="fa fa-chart-pie"></i>
			Projects Reporting
		</h2>

		<projects-toolbar-controls 
			:mobile-breakpoint="800">
		</projects-toolbar-controls>
	</toolbar>

	<total-billing-report v-if="!selectedType || selectedType == 'total-billing'"
		:selected-type="selectedType"
		v-on:selectedTypeChange="selectedType = $event">
	</total-billing-report>

	<monthly-billing-report v-else-if="selectedType == 'monthly-billing'"
		:selected-type="selectedType"
		v-on:selectedTypeChange="selectedType = $event">
	</monthly-billing-report>

</div>
</template>
<script type="text/javascript">
import ProjectsToolbarControls from "@/pages/project/ProjectsToolbarControls"
import Toolbar from "@/layout_fragments/Toolbar"
import Field from "@/components/Field"
import Widget from "@/components/Widget"
import ContextMenu from "@/layout_fragments/ContextMenu"

import TotalBillingReport from "./TotalBillingReport"
import MonthlyBillingReport from "./MonthlyBillingReport"

export default {
	name: "ReportsProjects",
	components: {
		Toolbar,
		ProjectsToolbarControls,
		Field,
		Widget,
		ContextMenu,
		TotalBillingReport,
		MonthlyBillingReport
	},
	data() {
		return {
			selectedType: 'total-billing'
		}
	},
	computed: {

	}
}
</script>